<template>
	<el-dialog
		title="自动发礼品设置"
		:visible.sync="visible"
		left
		@close="handlerCancel"
	>
		<div class="dialog-body">
			<el-checkbox v-model="checked">即将超时最后10分钟打单发货</el-checkbox>
		</div>
		<span slot="footer" class="dialog-footer">
	      <el-button @click="handlerCancel">取 消</el-button>
	      <el-button type="primary" @click="handlerConfirm">保存</el-button>
	    </span>
	</el-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
	data() {
		return {
			current_id: null,
			userinfo: 1,
			visible: false,
			list: [],
			params: {},
			func: {},
			callback: {},
			shop_id: null,
			checked: false,
		}
	},
	computed: {
		...mapState({
			users: (state) => state.login.userinfo,
		}),
	},
	mounted() {
		this.opPddAccountList({
			data: {
				page: 1,
				limit: 99999,
				type: 1,
                group_ids: [],
			},
			success: (res) => {
				this.list = res.data.data;
			}
		})
	},
	methods: {
		...mapActions({
			opPddAccountList: "ucenter_order/opPddAccountList",
			getUserinfoData: "ucenter_order/getUserinfoData"
		}),
		open(params, func, callback) {
			this.params = params;
			this.func = func;
			this.callback = callback
			this.visible = true;
			if (this.users) {
				this.refreshUserinfo()
				console.log('userinfo', this.userinfo)

			}
		},
		refreshUserinfo() {
			this.getUserinfoData({
				data: {}, success: (res) => {
					console.log('refresh userinfo success', res)
					this.userinfo = res.data
					this.checked = this.userinfo.is_auto_send_gift > 0 ? true : false
				}
			})
		},
		handlerConfirm() {
			this.func({
				data: {is_open: this.checked},
				success: (res) => {
					this.callback(res);
					this.visible = false;
				},
			})
		},
		handlerCancel() {
			this.visible = false;
		}
	}
}
</script>

<style scoped>
:deep(.el-dialog) {
	width: 400px;

}

:deep(.el-checkbox__label) {
	font-size: 16px;
}
</style>
